export default function direction(target: any, prop: string) {

  const NG_ON_ONIT_NAME = 'ngOnInit';

  /** ngOnInit might not be implemented by this component */
  const ngOnInitClone: Function|null = target[NG_ON_ONIT_NAME];

  Object.defineProperty(target, NG_ON_ONIT_NAME, {
    value: function() {
      if (this[prop]) {
        this[prop] = this[prop].toLowerCase();
        if ( ['ltr' , 'rtl'].indexOf(this[prop]) === -1 ) {
          console.error(
            target.constructor.name +
            `: ${this[prop]} is not valid direction value\nvalid values: {'ltr' , 'rtl'}`
          );
          this[prop] = 'ltr';
        }
      } else {
        this[prop] = 'ltr';
      }
      // Calling the original ngOnInit with its original context
      if( ngOnInitClone ) {
        ngOnInitClone.call(this);
      }
    }
  });
}
